import {usePromotionalProducts} from '../../../hooks/queries/recommendations';
import {CATEGORY_PROMOTIONAL_PRODUCTS} from '../../../utils/constants/categoryConstants';

const useTrendingProducts = () => {
  const {data, isError, isLoading} = usePromotionalProducts({
    queryParams: {categoryId: CATEGORY_PROMOTIONAL_PRODUCTS, limit: 20}
  });

  if (isError || (data && (!data.products || data.products.length === 0))) {
    return {
      isLoading: false,
      products: []
    };
  }

  return {
    isLoading,
    products: data?.products || []
  };
};

export default useTrendingProducts;
